<template>
    <div>
        <head-nav></head-nav>
        <div class="form-reg">
            <img src="../../img/mission-logo.png" style="max-width:300px; margin-left: -11px">
            <br>
            <br>
            <span style=" font-family: 'berleno';padding-top:15px;padding-bottom:15px">
                Please fill out the form below to become a registered member.
            </span>
            <br>
            <br>
            <form class="register-form" @submit.prevent="registerMet">
                <div class="row">
                    <div class="col-12 col-md-6 ">
                        <input v-model="register.firstName" name="firstname" placeholder="First Name" type="text">
                    </div>
                    <div class="col-12 col-md-6 ">
                        <input v-model="register.lastName" name="lastname" placeholder="Last Name" type="text">
                    </div>
                </div>
                <div>
                    <input v-model="register.company" name="company" placeholder="Company" type="text">
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 ">
                        
                        <input v-model="register.city" name="city" placeholder="City" type="text">
                    </div>
                    <div class="col-12 col-md-6 ">
                        <select v-model="register.country" id="country" name="country">
                            <option disabled value=""> Select Country</option>
                            <option v-for="country in countries" :key="country.code" :value="country.code">
                                {{ country.text }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 ">
                        <select v-model="register.gender" name="gender" id="pronouns">
                            <option disabled value="">Gender Pronouns</option>
                            <option v-for="pronoun in pronouns" :key="pronoun" :value="pronoun">
                                {{ pronoun }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 ">
                        <input v-model="register.age" name="age" placeholder="Age" type="text">
                    </div>
                </div>
                <div>
                    <input v-model="register.email" name="email" placeholder="Email Address" type="email">
                </div>
                <div class="password-container">
                    <input v-model="register.password" name="pass" placeholder="Password" :type="isPasswordVisible ? 'text' : 'password'">
                    <span @click="togglePasswordVisibility" class="eye-icon">
                        <i :class="isPasswordVisible ? 'icon-eye-hidden' : 'icon-eye'"></i>
                    </span>
                </div>
                <p v-if="passwordError" class="al">{{ passwordError }}</p>
                <div>
                   <!--  <span class="al">Password must have at least 8 characters.</span> -->
                    <input v-model="register.passwordConfirmation" name="pass2" placeholder="Repeat Password"
                        type="password">
                </div>
                <span class="al">By clicking sign up you agree to our Terms and that you have read our <a style="text-decoration: underline !important" href="https://www.missionmag.org/privacy-policy/">Privacy
                    Policy.</a> </span>
                <button class="btn btn-dark mt-2" name="submit" type="submit">Sign Up</button>
                <p class="message">Already registered? <router-link to="/login">Login</router-link></p>
            </form>
            <br>
            <a class="message" href="/the-magazine">Back to website</a>
        </div>
        <info></info>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import headNav from '../../components/navBar'
import info from '../../components/info';
import { auth, db } from '@/firebase';
import countries from '../../assets/data/countries.data.json'
import swal from 'sweetalert';

export default {
    components: {
        headNav,
        info

    },
    data() {
        return {
            pronouns: ['She/ Her', 'He / Him', 'They/ Them', 'Other'],
            countries: [],
            selectedCountry: null,
            isPasswordVisible: false,
        }
    },

    created() {
        this.loadCountries();
    },

    methods: {
        togglePasswordVisibility() {
            this.isPasswordVisible = !this.isPasswordVisible;
        },
        loadCountries() {
            this.countries = countries
        },
        async registerMet() {

            try {
                // Crear cuenta en Firebase Auth
                const userRegister = await auth.createUserWithEmailAndPassword(
                    this.register.email,
                    this.register.password,
                );
                const user = userRegister.user;
                const userLogin = await auth.signInWithEmailAndPassword(this.register.email, this.register.password);
                const loged = userLogin.user;
                if (!loged.emailVerified) {
                    await loged.sendEmailVerification();
                }

                // Obtener el token de ID
                const idToken = await loged.getIdToken();

                localStorage.setItem('token', idToken),
                    localStorage.setItem('logged', true),

                    // Guardar datos adicionales del usuario en Firestore
                    await db.collection('users').doc(user.uid).set({
                        firstName: this.register.firstName,
                        lastName: this.register.lastName,
                        company: this.register.company,
                        city: this.register.city,
                        country: this.register.country,
                        gender: this.register.gender,
                        age: this.register.age,
                        email: this.register.email,
                        createdAt: new Date(),
                    });
                swal({
                    title: "Your account was created.",
                    text: " You will receive an email to confirm the account creation.",
                    icon: "success",
                    buttons: false,
                    timer: 3000,
                });

                this.$router.push("/payment")

            } catch (error) {
                swal({
                    title: "Error",
                    text: JSON.stringify(error.message),
                    icon: "error",
                    buttons: false,
                    timer: 1500,
                });
            }

        },
        ...mapActions('inPlayer', [
            'registerUser',
            'login',
            'messageOperation'
        ]),
        ...mapMutations('inPlayer', [
            'registerLogin'
        ]),
        ...mapMutations('cart', [
            'getPackageId'
        ]),
    },
    computed: {
        ...mapState('inPlayer', [
            'register',
            'errorReg',
            'loginUser',
            'inplayerId'
        ]),
        ...mapState('cart', [
            'packageId'
        ]),
        passwordError() {
            if (this.register.password.length > 0 && this.register.password.length < 8) {
                return 'Password must have at least 8 characters.';
            }
            return '';
        },
    },

}
</script>

<style lang="scss">
.form-reg {
    position: relative;
    z-index: 1;
    background: #FFFFFF;
    max-width: 680px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-reg input {
    font-family: 'berleno';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}

.form-reg select {
    font-family: 'berleno';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 17px 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #757575
}


.form-reg button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}


.form-reg .message {
    font-family: berleno;
    margin: 15px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}

.form-reg .message a {
    margin: 15px 0 0;
    color: #212529;
    font-size: 15px;
}

.form-reg .al {
    margin: 15px 0 0;
    color: #212529;
    font-size: 11px;
    text-decoration: none;
}
.password-container {
  position: relative;
  display: flex;
  align-items: center;



  .eye-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
    user-select: none;
  }
}
</style>
